import React from 'react';
import { PacDrawerContext } from '../../contexts';

export const RenderWithUpdatedEventObject = ({ eventObject, Component }) => {
  const { setEventOutput } = React.useContext(PacDrawerContext) ?? {};
  React.useEffect(() => setEventOutput((evtObjPrev) => ({ ...evtObjPrev, ...eventObject })), []);
  return <>{Component}</>;
};
